import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TokenDataAccessModule } from '@edgvr-front/token/data-access';
import { BinariesDataAccessModule } from '@edgvr-front/binaries/data-access';
import { ApiDataAccessModule } from '@edgvr-front/api/data-access';
import { AccountDataAccessModule } from '@edgvr-front/account/data-access';
import {
  ACCOUNT_ACCESS_REJECTED_URL,
  AccountFeatureAccountAccessModule,
} from '@edgvr-front/account/feature/account-access';
import { COMPANY_ACCESS_REJECTED_URL } from '@edgvr-front/companies/feature/company-access';
import {
  DATA_POLLUTION_PREVIEW_CODE_URL,
  DATA_POLLUTION_PREVIEW_DATA_URL,
  DATA_POLLUTION_PREVIEW_FRAMEWORK_URL,
  DATA_PREVIEW_CODE_URL,
  DATA_PREVIEW_DATA_URL,
  DATA_PREVIEW_FRAMEWORK_URL,
  DataDataAccessModule,
} from '@edgvr-front/data/data-access';
import { COMPANY_BASE_URL } from '@edgvr-front/companies/util/company-url';
import { EdgvrPortalFeatureEnvModule } from '@edgvr-front/edgvr-portal/feature/env';
import { NotificationsFeatureNotificationsModule } from '@edgvr-front/notifications/feature/notifications';
import { EdgvrPortalFeatureTemplateModule } from '@edgvr-front/edgvr-portal/feature/template';
import { SentryFeatureModule } from '@edgvr-front/sentry/feature';
import { VERSION } from '@edgvr-front/util/version';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../../../edgvr-portal/src/environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(
      {
        router: routerReducer,
      },
      {
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    AppRoutingModule,
    TokenDataAccessModule.forRoot({
      domain: environment.domain,
      tokenName: environment.tokenName,
    }),
    ApiDataAccessModule.forRoot({
      apiUrl: environment.apiUrl,
    }),
    AccountDataAccessModule,
    AccountFeatureAccountAccessModule,
    EdgvrPortalFeatureEnvModule.forRoot(environment),
    EdgvrPortalFeatureTemplateModule,
    NotificationsFeatureNotificationsModule,
    SentryFeatureModule.forRoot({
      dsn: environment.sentry.dsn,
      env: environment.sentry.env,
      version: VERSION.raw,
    }),
    BinariesDataAccessModule,
    DataDataAccessModule,
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      deps: [DOCUMENT],
      useFactory: (document: Document) => document.location.origin,
    },
    {
      provide: COMPANY_BASE_URL,
      useValue: environment.portalUrl,
    },
    {
      provide: ACCOUNT_ACCESS_REJECTED_URL,
      useValue: environment.frontUrl,
    },
    {
      provide: COMPANY_ACCESS_REJECTED_URL,
      useValue: environment.frontUrl,
    },
    {
      provide: DATA_PREVIEW_DATA_URL,
      useValue: environment.dataPreview.dataUrl,
    },
    {
      provide: DATA_PREVIEW_FRAMEWORK_URL,
      useValue: environment.dataPreview.frameworkUrl,
    },
    {
      provide: DATA_PREVIEW_CODE_URL,
      useValue: environment.dataPreview.codeUrl,
    },
    {
      provide: DATA_POLLUTION_PREVIEW_DATA_URL,
      useValue: environment.dataPollutionPreview.dataUrl,
    },
    {
      provide: DATA_POLLUTION_PREVIEW_FRAMEWORK_URL,
      useValue: environment.dataPollutionPreview.frameworkUrl,
    },
    {
      provide: DATA_POLLUTION_PREVIEW_CODE_URL,
      useValue: environment.dataPollutionPreview.codeUrl,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
